import {Avatar, Radio, DatePicker, Divider, Input, message, Upload} from "antd";
import config from "@/config";
import {useState} from "react";
import AccountInfo from "@/pages/account/profile/sections/ProfileSettings/components/AccountInfo";
import AccountSecurity from "@/pages/account/profile/sections/ProfileSettings/components/AccountSecurity";
import AccountAdvancedInfo from "@/pages/account/profile/sections/ProfileSettings/components/AccountAdvancedInfo";

export const ProfileSettings = () => {

    const [fullname, setFullname] = useState(null);


    const user = {
        avatar: config.webConfig.defaultAvatar,
        fullname: "Nguyễn Đình Tuấn",
        firstname: "Nguyễn Đình",
        lastname: "Tuấn",
        birthday: "2000-01-01",
        phone: "0123456789",
        address: "114/188 Tô Ngọc Vân P15 Q.Gò Vấp",
        gender: "Nam",
        email: "tuanndps36835@fpt.edu.vn",
    }

    // const handleUpload = (e) => {
    //     setImg(URL.createObjectURL(e.file.originFileObj));
    //     setAvatar(true);
    //     message.success('Upload avatar thành công', 1);
    // }
    //
    // const changeAvatar = (newAvatar) => {
    //     setImg(newAvatar);
    //     setAvatar(true);
    //     message.success('Thay đổi avatar thành công', 1);
    // }

    const handleConfirm = () => {
        message.success('Lưu thay đổi thành công', 1);
    }
    return (
        <div className={"container px-3 mx-auto"}>
            <AccountInfo/>
            <Divider/>
            <AccountSecurity/>
            <Divider/>
            <AccountAdvancedInfo/>
            <div className={"flex justify-center mt-4"}>
                <button
                    onClick={handleConfirm}
                    className={"bg-primary hover:bg-primary-hover transition-all text-white p-2 w-1/2 rounded-lg"}>Lưu
                    thay đổi
                </button>
            </div>
        </div>
    )
}